import React, { useEffect } from "react";
import ReactECharts from 'echarts-for-react';
import { LineChartLegendIcon, isMobileView, chartLegendIcon, roundOfToZero, getDOMTextWidth, getMaxOfArray, getDOMTextDimensions } from "../../utils/Reusables";
import _, { set } from "lodash";

export default function ClusteredBarComboChart(props) {
    const { resultSet, COLORS_SERIES, isLegendVisible, pivotConfig, dateFieldFormat, handleCategoryData, columnTitle, legendPosition, columnDisplayName, settings, timeDimensionDateFormat, reportIn = null, h = null, hasFilters = null, hasLinkedReports = null, comparisonChartType } = props;
    const [isLegendsUnchecked, setIsLegendsUnchecked] = React.useState(false);
    const [echartRef, setEchartRef] = React.useState(null);
    const [echartInstance, setEchartInstance] = React.useState(null);

    const [axisVisibility, setAxisVisibility] = React.useState(true);
    const [gridBottomPosition, setGridBottomPosition] = React.useState(0);
    const [gridLeftPosition, setGridLeftPosition] = React.useState(10);
    const [gridTopPosition, setGridTopPosition] = React.useState(15);
    const [gridRightPosition, setGridRightPosition] = React.useState(0);
    
    //let isLegendPaged = isMobileView() ? isLegendVisible && settings?.mobile?.legendPagination : isLegendVisible && settings?.mobile?.legendPagination;
    //let isDashboardReportNonPaginated = (reportIn === "dashboard" && !isLegendPaged  &&  (legendPosition === 'top' || legendPosition === 'bottom'));
    let isDashboardReportNonPaginated = (reportIn === "dashboard");
    /* 224 - card padding, header height, filter height, margin above chart; 54 - filter height, linked reports - 64, canvas margin - 16 */
    let hasLinkedReportsSpacing = hasLinkedReports ? 0 : 64;
    let hasFiltersSpacing = (hasFilters && !isDashboardReportNonPaginated) ? 0: 54;
    let comparisonChartSpacing = comparisonChartType ? 20 : 0;
    let cardSpacing = isDashboardReportNonPaginated ? (224 - hasFiltersSpacing - hasLinkedReportsSpacing) : 0;
    const defaultHeight = (reportIn === "dashboard" && isDashboardReportNonPaginated) ? ((h * 10) + ((h-1) * 20) - cardSpacing - comparisonChartSpacing) : 300;
    const [chartHeight, setChartHeight] = React.useState(defaultHeight);
    const [gridHeight, setGridHeight] = React.useState('auto');
    const chartParentRef = React.useRef(null);
    const [legendHeight, setLegendHeight] = React.useState(30);
    const [seriesData, setSeriesData] = React.useState([]);
    const [xAxisCategories, setxAxisCategories] = React.useState([]);
    const [chartLegendValues, setChartLegendValues] = React.useState([]);
    const [YValues, setYValues] = React.useState([])
    const [xAxisMaxLabelLength, setXAxisMaxLabelLength] = React.useState(0);
    const [xAxisFirstLabelWidth, setXAxisFirstLabelWidth] = React.useState(0);
    const [innerGridHeight, setInnerGridHeight] = React.useState(250);
    const [iconData, setIconData] = React.useState([]);

    React.useEffect(() => {
        let chartInnerHeight = isMobileView() ? Number(settings?.mobile?.innerChartHeight) : Number(settings?.web?.innerChartHeight);
        if(chartInnerHeight >= 100) {
            setInnerGridHeight(chartInnerHeight);
        }
    }, [settings?.mobile?.innerChartHeight, settings?.web?.innerChartHeight]);

    React.useEffect(() => {
        
        let chartLegendValuesData = [];
        let yValuesData = [];
        const _iconData = [];
        const series = resultSet.series(pivotConfig).map((s, index) => {
            let chartLabelData = handleChartLabel(columnTitle, columnDisplayName, s);
            chartLegendValuesData.push(chartLabelData);
            _iconData.push({ name: chartLabelData, icon: pivotConfig?.lines?.find(obj => s.key?.split(',')?.includes(obj.text)) ? LineChartLegendIcon() : chartLegendIcon() })
            return {
                name: handleChartLabel(columnTitle, columnDisplayName, s),
                data: s.series.map((r, i) => {
                    let dataObj = { value: (r?.value === undefined || r?.value === null || r?.value === 'NaN' || r?.value === Infinity) ? 0 : roundOfToZero(r?.value,s?.key,settings) }
                    dataObj.itemStyle = {
                        color: settings?.showMultiColoredBar ? COLORS_SERIES[i] : null,
                    }
                    yValuesData.push(r?.value);
                    return dataObj
                }),
                backgroundColor: COLORS_SERIES[index],
                type: pivotConfig?.lines?.find(obj => s.key?.split(',')?.includes(obj.text)) ? 'line' : 'bar',
                stack: pivotConfig?.lines?.find(obj => s.key?.split(',')?.includes(obj.text)) ? false : 'bar',
                label: {
                    show: settings?.showBarValueOnTop ?? true,
                    position: settings?.barValuePosition ?? 'right',
                },
                labelLayout: {
                    hideOverlap: true,
                }
            }
        });
        setIconData(_iconData);
        setSeriesData(series);
        setChartLegendValues(chartLegendValuesData);
        setYValues(yValuesData);
    
        const result = handleCategoryData(resultSet, dateFieldFormat, pivotConfig, timeDimensionDateFormat)
        let xAxisCategoriesData = result.categories.map(obj => obj)
        setxAxisCategories(xAxisCategoriesData);
    }, [resultSet, pivotConfig]);

    React.useEffect(() => {
        let maxYValuesLength =  YValues?.length ? (Math.ceil(_.max(YValues)).toString().length * 10 + 10) : 15;
        let leftPosition = axisVisibility && settings?.axisTitle?.y?.text
                                ?   maxYValuesLength + 20
                                :   maxYValuesLength
        leftPosition = isLegendsUnchecked ? leftPosition + 15 : leftPosition
        if(legendPosition === 'left') {
            leftPosition = isLegendVisible ? leftPosition + 125 : leftPosition;
        }
        
        if(legendPosition === 'right') {
            setGridRightPosition(isLegendVisible ? 125 : 0)
        } else {
            setGridRightPosition(0)
        }
        if(xAxisFirstLabelWidth > (leftPosition + 20)){
            leftPosition = leftPosition + xAxisFirstLabelWidth - maxYValuesLength - ((axisVisibility && settings?.axisTitle?.y?.text) ? 30 : 15); // 15 spacing between first label and left pos, 15 is axis title width
        }
        setGridLeftPosition(leftPosition);
    }, [isLegendsUnchecked, YValues, legendPosition, axisVisibility, settings, isLegendVisible, xAxisFirstLabelWidth]);

    React.useEffect(() => {
        let gridTopMargin = 15;
        if(settings?.showBarValueOnTop) gridTopMargin = 25;

        if(legendPosition === 'top') {
            setGridTopPosition((legendHeight > 15) ? legendHeight + gridTopMargin : gridTopMargin);
        } else {
            setGridTopPosition(gridTopMargin);
        }
    }, [legendHeight, legendPosition, settings?.showBarValueOnTop]);

    React.useEffect(() => {
        if(isMobileView()) {
            if(settings?.mobile?.showXaxisLabel) {
                setAxisVisibility(true);
            } else {
                setAxisVisibility(false);
            }
        } else {
            if(settings?.web?.showXaxisLabel) {
                setAxisVisibility(true);
            } else {
                setAxisVisibility(false);
            }
        }

    }, [settings]);

    useEffect(() => {
        let labelMaxLen;

        if (axisVisibility) {
            let xAxisItemsList = xAxisCategories?.filter(item => item);
            if (xAxisItemsList.length > 0) {
                let maxLabelString = getMaxOfArray(xAxisCategories).toString();
                if(maxLabelString.includes("\n")) {
                    let maxLabelValArr = maxLabelString.split("\n");
                    maxLabelString = getMaxOfArray(maxLabelValArr).toString();
                }
               let maxTruncateString = isMobileView()
                                        ?   (settings?.mobile?.truncateLabel && Number(settings?.mobile?.maxLabelCharacters))
                                                ? (maxLabelString.length > Number(settings?.mobile?.maxLabelCharacters)) 
                                                    ?   maxLabelString.substring(0, Number(settings?.mobile?.maxLabelCharacters)) + '...'
                                                    :   maxLabelString
                                                : maxLabelString
                                        :   (settings?.web?.truncateLabel && Number(settings?.web?.maxLabelCharacters))
                                                ? (maxLabelString.length > Number(settings?.web?.maxLabelCharacters)) 
                                                    ?   maxLabelString.substring(0, Number(settings?.web?.maxLabelCharacters)) + '...'
                                                    :   maxLabelString
                                                : maxLabelString

                let labelDimensions = getDOMTextDimensions(maxTruncateString, '12px sans-serif', '17px', parseInt(settings?.xAxisLabelDegree))
                labelMaxLen = labelDimensions.h + 10; // 10px gap between axis title and label
            } else {
                labelMaxLen = 0;
            }
        } else {
            labelMaxLen = 0;
        }
        setXAxisMaxLabelLength(labelMaxLen);
        let firstLabelDimension = getDOMTextDimensions(xAxisCategories[0], '12px sans-serif', '17px', parseInt(settings?.xAxisLabelDegree))
        setXAxisFirstLabelWidth(firstLabelDimension.w);
    }, [xAxisCategories, settings, axisVisibility]);

    React.useEffect(() => {
        if(echartRef) setEchartInstance(echartRef.getEchartsInstance());
    }, [echartRef]);

    React.useEffect(() => {
        handleChartHeight()
    }, [resultSet, legendHeight, legendPosition, isLegendVisible, settings, xAxisMaxLabelLength, innerGridHeight, gridBottomPosition, gridTopPosition]);

    React.useEffect(() => {
    handleChartDimensions();
    }, [resultSet, chartParentRef, isLegendVisible, legendPosition, settings, chartLegendValues]);

    const handleChartHeight = () => {
        let axisVisible = isMobileView() ? settings?.mobile?.showXaxisLabel : settings?.web?.showXaxisLabel;
        let isLegendPaginated = isMobileView() ? isLegendVisible && settings?.mobile?.legendPagination : isLegendVisible && settings?.web?.legendPagination;
        let axisTitleHeight = settings?.axisTitle?.x?.text && axisVisible ? 30 : 0; // reducing 30 to 15, as axis height considered as part of grid height
        //let isDashboardReportNonPaginated = (reportIn === "dashboard" && !isLegendPaginated && (legendPosition === 'top' || legendPosition === 'bottom'));
        let isDashboardReportNonPaginated = (reportIn === "dashboard");
        let totalGridHeight = innerGridHeight - gridBottomPosition - gridTopPosition;
        if(isDashboardReportNonPaginated) totalGridHeight = defaultHeight - legendHeight - axisTitleHeight - xAxisMaxLabelLength - gridBottomPosition - gridTopPosition - 10; // // 10px reduced as chart height increased by 10px in line 195
        setGridHeight(totalGridHeight);

        let totalChartHeight = gridBottomPosition + gridTopPosition + totalGridHeight + axisTitleHeight + legendHeight + xAxisMaxLabelLength + 20;  // 10 - spacing additional
        setChartHeight(totalChartHeight);
    }
    
    const handleChartDimensions = () => {
        if(isLegendVisible) {
          let isLegendPagination = isMobileView() ? settings?.mobile?.legendPagination : settings?.web?.legendPagination;

          if(isLegendPagination) {
            if(legendPosition === 'top' || legendPosition === 'bottom') {
                setLegendHeight(30);
            } else {
                setLegendHeight(0);
            }
            
          } else {
            if(legendPosition === 'top' || legendPosition === 'bottom') {
                let labelLengths = chartLegendValues?.map(label => {
                return getDOMTextWidth(label, '12px sans-serif')
                })
                labelLengths = labelLengths?.map(item => item + 47);
                let totalLegendLines = 0;
                let totalLegendLineStringWidth = 0;
                let cardWidth = chartParentRef?.current?.clientWidth - 20; /* left margin */
                (cardWidth && labelLengths?.length) && labelLengths?.forEach((item, i) => {
                    totalLegendLineStringWidth += item;
                    if(totalLegendLineStringWidth > cardWidth) {
                        totalLegendLines++;
                        totalLegendLineStringWidth = item;
                    }
                });
                totalLegendLines++;
                let totalLegendHeight = 30 * totalLegendLines;
                setLegendHeight(totalLegendHeight);
            } else {
                setLegendHeight(0);
            }
          }
        } else {
          setLegendHeight(0);
        }
        
    }

    

    let width = '80%'
    let legend = {}
    let legendWidth;
    let gridOptions = {
        containLabel: false,
        left: gridLeftPosition,
        top: gridTopPosition,
        right: gridRightPosition,
        bottom: gridBottomPosition,
        height: gridHeight
    }

    const legendWidthForTopBottomPositions = () => {
        var legendValues = chartLegendValues?.filter(n => n);
          let legendLabelsCount;
          if(!isMobileView() && settings?.web?.legendPagination && settings?.web?.maxLegendsCount){
            legendLabelsCount = settings?.web?.maxLegendsCount
          } else if(isMobileView() && settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount) {
            legendLabelsCount = settings?.mobile?.maxLegendsCount
          } else {
            return null;
          }
          
          let maxLabelValues = legendValues?.slice(0, legendLabelsCount);
          let labelLengthsWeb = maxLabelValues?.map(label => {
            return getDOMTextWidth(label, '12px sans-serif')
          })
          
          let legendWidth = (labelLengthsWeb.reduce((a, b) => a + b, 0) + (45 * labelLengthsWeb?.length));
          return legendWidth;
    }

    switch (legendPosition) {
        case 'right':
            legend = {
                orient: 'vertical',
                left: 'right',
                top: 0,
                type: 'scroll',
                show: isLegendVisible,
                // icon: chartLegendIcon(),
                data: iconData,
                formatter: function (name) {
                    if (name?.length > 12) {
                        return name.substring(0, 12) + '...'
                    }
                    return name;
                },
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions.width = (chartParentRef?.current?.clientWidth - gridLeftPosition - gridRightPosition);
            //gridOptions.height = axisVisibility ?  'auto' : '100%';

            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile.maxLegendsCount && isMobileView()) {
                legend.height = Number(settings?.mobile.maxLegendsCount) * 30 + 24
            }
            else {
                delete legend?.height
            }

            break;
        case 'bottom':
            width = '93%'
            legend = {
                orient: 'horizontal',
                bottom: 0,
                left: '10px',
                itemGap: 10,
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                // icon: chartLegendIcon(),
                data: iconData,
                formatter: null,
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions.width = 'auto';
            //gridOptions.height = axisVisibility ?  'auto' : '100%';

            legendWidth = legendWidthForTopBottomPositions();
            if(legendWidth) {
                legend.width = legendWidth;
            } else {
                delete legend?.width;
            }

            break;
        case 'top':
            width = '93%'
            legend = {
                orient: 'horizontal',
                top: -6,
                left: '10px',
                type: isMobileView() ? (settings?.mobile?.legendPagination ? 'scroll' : 'plain') : (settings?.web?.legendPagination ? 'scroll' : 'plain'),
                show: isLegendVisible,
                // icon: chartLegendIcon(),
                data: iconData,
                formatter: null,
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions.width = 'auto';
            //gridOptions.height = axisVisibility ?  'auto' : '100%';

            legendWidth = legendWidthForTopBottomPositions();
            if(legendWidth) {
                legend.width = legendWidth;
            } else {
                delete legend?.width;
            }

            break;
        case 'left':
            legend = {
                orient: 'vertical',
                left: 'left',
                top: 0,
                type: 'scroll',
                show: isLegendVisible,
                // icon: chartLegendIcon(),
                data: iconData,
                formatter: function (name) {
                    if (name?.length > 12) {
                        return name.substring(0, 12) + '...'
                    }
                    return name;
                },
                itemHeight: 20,
                textStyle: {
                    fontSize: 12,
                    lineHeight: 20,
                },
            }
            gridOptions.width = 'auto';
            //gridOptions.height = axisVisibility ?  'auto' : '100%';

            if (settings?.web?.legendPagination && settings?.web?.maxLegendsCount && !isMobileView()) {
                legend.height = Number(settings?.web?.maxLegendsCount) * 30 + 24
            }
            else if (settings?.mobile?.legendPagination && settings?.mobile?.maxLegendsCount && isMobileView()) {
                legend.height = Number(settings?.mobile?.maxLegendsCount) * 30 + 24
            }
            else {
                delete legend?.height
            }
            break;
    }

    if (!isLegendVisible) {
        width = '93%'
        legend = {
            show: false,
        }
        
    }

    let axisLabel = {
        rotate: axisVisibility ? settings?.xAxisLabelDegree : 0,
        // overflow: "truncate",
        // lineOverflow: 'truncate',
        color: '#202124',
        fontWeight: 'normal'
    }

    if (isMobileView()) {

        if (settings?.mobile?.truncateLabel && Number(settings?.mobile?.maxLabelCharacters)) {
            axisLabel.formatter = function (name, i) {
                
                if (name?.length <= Number(settings?.mobile?.maxLabelCharacters)) {
                    return name;
                }
                return name.substring(0, Number(settings?.mobile?.maxLabelCharacters)) + '...';
            }
        }
        else {
            axisLabel.formatter = (name, i) => {
                
                return name
            }
        }
    }
    else {

        if (settings?.web?.truncateLabel && Number(settings?.web?.maxLabelCharacters)) {
            axisLabel.formatter = function (name, i) {
                
                if (name?.length <= Number(settings?.web?.maxLabelCharacters)) {
                    return name;
                }
                 return name.substring(0, Number(settings?.web?.maxLabelCharacters)) + '...';
            }
        }
        else {
            axisLabel.formatter = (name, i) => {
                
                return name
            }
        }
    }

    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                crossStyle: {
                    color: '#999'
                }
            },
            appendToBody: true,
            confine: true,
        },
        grid: gridOptions,
        xAxis: [
            {
                type: 'category',
                offset: 5,
                axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#dedede"
                    }
                },
                show: isMobileView() ? settings?.mobile?.showXaxisLabel : settings?.web?.showXaxisLabel,
                data: xAxisCategories,
                axisPointer: { type: 'shadow' },
                axisLabel,
                name: axisVisibility && settings?.axisTitle?.x?.text ? settings?.axisTitle?.x?.text : '',
                nameTextStyle: {
                    fontSize: 12,
                    lineHeight: 17,
                    height: 24,
                    fontWeight: 'bold',
                    fontFamily: 'Open Sans',
                    color: '#202124'
                },
                nameLocation: 'middle',
                hideOverlap: false,
                nameGap:  ( (xAxisCategories?.length > 0 ) && axisVisibility
                                ?   xAxisMaxLabelLength + 10 // spacing between label and title - 10
                                :   15
                        )

            }
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    lineStyle: {
                        color: '#dedede',
                        width: 0.8,
                    }
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#dedede"
                    }
                },
                min: 0,
                max: settings?.axisSettings?.y?.left?.max ? Number(settings?.axisSettings?.y?.left?.max) : null,
                interval: settings?.axisSettings?.y?.left?.interval ? Number(settings?.axisSettings?.y?.left?.interval) : null,
                name: axisVisibility && settings?.axisTitle?.y?.text ? settings?.axisTitle?.y?.text : '',
                nameTextStyle: {
                    fontSize: 12,
                    lineHeight: 17,
                    height: 24,
                    fontWeight: 'bold',
                    fontFamily: 'Open Sans',
                    color: '#202124'
                },
                axisLabel: {
                    color: '#202124',
                    fontWeight: 'normal'
                },
                nameLocation: 'middle',
                minInterval: 1,
                nameGap: YValues.filter(i => i)?.length ? Math.ceil(_.max(YValues)).toString().length * 10 + 10 : 10
            }
        ],
        legend: legend,
        series: seriesData,
        color: COLORS_SERIES,
        //width,
    };
    

    if (settings?.mobile?.horizontalScroll && isMobileView() && xAxisCategories?.length >= settings?.mobile?.maxBarsCount) {
        options.dataZoom = [
            {
                type: 'inside',
                zoomLock: true,
                height: 10,
                showDetail: false,
                startValue: 0,
                endValue: Number(settings?.mobile?.maxBarsCount) - 1,
                preventDefaultMouseMove: false
            }
        ]
    }
    else if (settings?.web?.horizontalScroll && !isMobileView() && xAxisCategories?.length >= settings?.web?.maxBarsCount) {
        options.dataZoom = [
            {
                type: 'inside',
                zoomLock: true,
                height: 10,
                showDetail: false,
                startValue: 0,
                endValue: Number(settings?.web?.maxBarsCount) - 1,
                preventDefaultMouseMove: false
            }
        ]
    }
    else {
        options.dataZoom = [
            {
                type: 'inside',
                zoomLock: true,
                showDetail: false,
                start: 0,
                end: 100,
                preventDefaultMouseMove: false
            }
        ]
    }

    const toggleLegends = React.useCallback((params) => {
        var _uncheckedFlags = [];
        echartInstance && echartInstance.dispatchAction({
            type: 'legendSelect',
            name: params.name,
        })
        if(params.selected){
            for(const item in params.selected) {
                _uncheckedFlags.push(params.selected[item])
                // if(legend !== params.name) {
                //     echartInstance && echartInstance.dispatchAction({
                //         type: 'legendUnSelect',
                //         name: legend,
                //     })
                // }
            }
        }
        let allLegendsUnchecked = _uncheckedFlags.every(v => v === false);
        setIsLegendsUnchecked(allLegendsUnchecked);

    }, []);

    const onEvents = {
        legendselectchanged: toggleLegends,
    };

    //console.log("CCC", chartHeight, legendHeight, gridHeight, xAxisMaxLabelLength, options);
    return (
        <div className={(settings?.mobile?.horizontalScroll || settings?.web?.horizontalScroll) ? `echart-hscroll-enabled` : 'report-chart-wrapper'}
            ref={chartParentRef} style={{marginRight: '10px'}} >
                <ReactECharts 
                    style={{
                        height: chartHeight + 'px', 
                        width: '100%'
                    }} 
                opts={{ renderer: 'svg' }}
                    option={options}
                    onEvents={onEvents} 
                    ref={(e) => {setEchartRef(e)}}
                />
        </div>
    )
}

const handleChartLabel = (columnTitle, columnDisplayName, s) => {
    let label;
    let key = s?.key
    let columnLabel = { ...columnDisplayName }
    if (columnTitle && columnTitle.length && Object.keys(columnTitle[0]).length) {
        for (let title of Object.keys(columnTitle[0])) {
            if (columnTitle[0][title]) {
                columnLabel[title] = columnTitle[0][title]
            }
        }
    }

    if (key && columnLabel && Object.keys(columnLabel).length && columnLabel[key]) {
        label = columnLabel[key]
        if (Object.keys(columnLabel).length === 1) {
            if (columnLabel[key].trim() === '') {
                label = label.replace(',', '')
            }
        }
        else {
            for (let index = 0; index < Object.keys(columnLabel).length; index++) {
                if (index !== 0) {
                    if (key === Object.keys(columnLabel)[index] && columnLabel[Object.keys(columnLabel)[index - 1]].trim() === '') {
                        label = columnLabel[key].replace(',', '')
                    }
                }
            }
        }
    }
    else if (key && columnLabel && Object.keys(columnLabel).length) {
        for (let col of Object.keys(columnLabel)) {
            if (key.includes(col)) {
                let temp = key;
                if (columnLabel[col].trim() === '') {
                    key = key.replace(`,${col}`, columnLabel[col]);
                    if (temp === key) {
                        key = key.replace(col, columnLabel[col]);
                    }
                }
                else {
                    key = key.replace(col, columnLabel[col]);
                }
                label = key;
            }
        }
    }
    else {
        label = s?.title
    }
    return label;
}
